import Vue from 'vue';
import App from './App.vue';
import { PostKsjMessageFactory } from './ksjIframe';

import './style.css';

Vue.config.productionTip = false;

// 初始化PostKsjMessageFactory
let postKsjMessage = new PostKsjMessageFactory();
postKsjMessage.init('bimIframeId');

// 注册方法$postKsjMessage 
Vue.prototype.$postKsjMessage = function (data, callback) {
  postKsjMessage.postMessage(data, callback);
}

new Vue({
  render: h => h(App),
}).$mount('#app');

// 页面卸载
window.addEventListener('unload', () => {
  postKsjMessage.unint();
});
